import * as React from "react";
import { Redirect } from "expo-router";

// import { isLocalhost } from "~/lib/constants";
import { useGlobalStore } from "~/stores/global";

export default function Home() {
  const store = useGlobalStore(true);
  const personalAccount = store.store.personalAccount;

  if (!personalAccount) {
    return <Redirect href="/create-account/" />;
  }

  return (
    <Redirect
      href={{
        pathname: "/(app)/(authenticated)/[account]/(account)",
        params: {
          account: personalAccount.slug,
        },
      }}
    />
  );
}
//
